// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"41e64834","198":"bf1102c9","974":"0c81936a"}[chunkId] + ".chunk.css";
};